export default __webpack_public_path__ + "static/media/breakfast.fdd2a686.svg";